import { ChangeDetectorRef, Component, ElementRef, Input, OnInit, Signal, ViewChild, inject } from '@angular/core';
import Chart, { ChartConfiguration, ChartConfigurationCustomTypesPerDataset } from 'chart.js/auto';
import 'chartjs-adapter-dayjs-4';
import { AssessmentChartDataRow, AssessmentChartDataSets } from '../../services/model';

@Component({
  selector: 'app-example-chart',
  standalone: true,
  imports: [],
  template: '<canvas style="width:100%" #canvas id="chartId"></canvas>', // (mouseout)="mouseOut($event)"
})
export class ExampleChartComponent implements OnInit {
  public chart: any;
  @ViewChild('canvas', { read: ElementRef, static: true }) canvas!: ElementRef<any>;

  private cdr: ChangeDetectorRef = inject(ChangeDetectorRef);

  private maxY = 19 * 3; // maximal mögliche Punktzahl ist bei 19 Fragen und 3 Punkten je Frage

  constructor() {}

  ngOnInit(): void {
    setTimeout(() => {
      this.createChart();
      this.cdr.detectChanges();
    }, 100);
  }

  createChart() {
    const config: ChartConfiguration | ChartConfigurationCustomTypesPerDataset = {
      type: 'line', // oder 'line', 'pie', etc.
      data: {
        labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
        datasets: [
          {
            label: 'Dataset 1',
            backgroundColor: 'rgb(255, 99, 132)',
            borderColor: 'rgb(255, 99, 132)',
            data: [0, 10, 5, 2, 20, 30, 45],
          },
        ],
      },
      options: {
        aspectRatio: 3,
        scales: {
          y: {
            // min: 0,
            // max: 100,
            // reverse: false,
            position: 'right',
            // beginAtZero: true,
            // grid: {
            //   display: false,
            // },
          },
        },
        plugins: {
          legend: {
            position: 'top', // Position der Legende
            align: 'start', // Ausrichtung der Legende
            labels: {
              padding: 20, // optionaler Padding-Wert
            },
          },
        },
      },
    };

    this.chart = new Chart(this.canvas.nativeElement, config);
  }
}
